import { useState } from "react"

// Drawer-Switches und Map-Anzeige-Toggles (gepflegt über DrawerList/MapPanel).
export function useUiToggles() {
  const [switchVoyagePlannerActive, setSwitchVoyagePlannerActive] =
    useState(false)
  const [switchRnwAnalyserActive, setSwitchRnwAnalyserActive] = useState(false)
  const [switchGisLayersActive, setSwitchGisLayersActive] = useState(false)
  const [switchMapSettingsActive, setSwitchMapSettingsActive] = useState(false)
  const [plannerRoutingMode, setPlannerRoutingMode] = useState("time")
  const switchManualPathing = plannerRoutingMode === "manual"

  const [toogleButtonsOnOff, setToogleButtonsOnOff] = useState(() => [
    "Minimap",
    "NautiScale",
    "ZoomControl",
    "Attribution",
    "LatLon",
    "Graticule",
    "PolylineMeasure", //,'LeafletVelocity','Pixi','Windflow', // -> ToggleButtonsHud.js
    "ReportedRoute",
    "PlanRoute",
    //"ECA",
    //"HighRisk", // 'WDPA Point','Loadline','Port','City','Country','River','Lake','Canal',... // -> ToggleButtonsGeoVectorLayers.js
  ])
  const handleToogleButtonsOnOff = (event, newToogleButtonsOnOff) => {
    setToogleButtonsOnOff(newToogleButtonsOnOff)
  }

  return {
    switchVoyagePlannerActive,
    setSwitchVoyagePlannerActive,
    switchRnwAnalyserActive,
    setSwitchRnwAnalyserActive,
    switchGisLayersActive,
    setSwitchGisLayersActive,
    switchMapSettingsActive,
    setSwitchMapSettingsActive,
    plannerRoutingMode,
    setPlannerRoutingMode,
    switchManualPathing,
    toogleButtonsOnOff,
    setToogleButtonsOnOff,
    handleToogleButtonsOnOff,
  }
}
